import React from "react"
import { Link } from "gatsby"
import HeroHome from "../../images/team-home.svg"

const Hero = () => {
  return (
    <section className="container mx-auto pt-8 pb-20">
      <div className="flex flex-col-reverse md:flex-row lg:content-end">
        <div className="mt-4 w-full md:w-1/2 px-6 pb-6 self-center">
          <h2 className="text-4xl md:text-3xl lg:text-6xl pb-5 leading-normal">
            <span className="text-6xl md:text-5xl lg:text-7xl block font-bold text-secondary">A Family</span> of motivated <b>Developers</b>
          </h2>        
          <p className="text-2xl md:text-xl pb-8">
            We are passionate about the development of <b>digital products</b>. We have been empowering big companies from our home for more than <b>10 years</b>.
          </p>
          <Link
            to="/contact"
            className="mr-5 hover:text-white shadow-lg hover:bg-secondary hover:text-variant btn"
          >
            Get to know us
          </Link>
        </div>
        <div className="w-full md:w-1/2">
          <img
            src={HeroHome}
            alt="A family of motivated devolepers"
            className="mx-auto"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
